import { useState } from 'react'

/**
 * Atalho para a tela inicial, onde se informa o CNPJ.
 *
 * POR QUE COM CONFIRMAÇÃO
 *
 * O toque é pequeno e fica no topo, ao lado da marca — a área que num celular a
 * pessoa acerta sem querer ao rolar. Voltar por acidente da etapa 5 para a
 * primeira não apaga nada, mas assusta: quem vê o formulário do CNPJ de novo
 * conclui que perdeu o que preencheu, e a conclusão errada custa uma ligação (ou
 * um abandono).
 *
 * A confirmação é INLINE, não um modal. Modal exige prender o foco, tratar Esc,
 * devolver o foco ao voltar e não brigar com o teclado do celular; para uma
 * pergunta de duas opções, o custo não se paga. Aqui o próprio botão vira a
 * pergunta, e é impossível confirmar sem ler.
 *
 * O TEXTO DIZ A VERDADE, e ela tem duas metades:
 *   · o que está preenchido continua salvo e volta ao recarregar a página;
 *   · MAS iniciar outro CNPJ deixa este preenchimento para trás — o navegador
 *     passa a apontar para o novo, e o antigo só volta pelo link do e-mail.
 * Omitir a segunda metade tornaria a confirmação uma formalidade: ela existe
 * justamente para a pessoa que ia trocar de CNPJ sem saber disso.
 */
export function AtalhoInicio({ aoIr }: { aoIr: () => void }) {
  const [armado, setArmado] = useState(false)

  if (!armado) {
    return (
      <button type="button" className="atalho-inicio" onClick={() => setArmado(true)}>
        Ir para a tela inicial
      </button>
    )
  }

  return (
    /* `role="group"` com nome: no leitor de tela a pergunta e as duas ações
       chegam juntas, em vez de dois botões soltos sem contexto. */
    <div className="atalho-inicio__confirma" role="group" aria-label="Confirmar volta ao início">
      <p className="atalho-inicio__texto">
        Voltar para a tela do CNPJ? O que você preencheu <strong>continua salvo</strong> — mas se
        você iniciar outro CNPJ, este preenchimento fica para trás.
      </p>
      <div className="atalho-inicio__acoes">
        <button
          type="button"
          className="botao botao--secundario botao--miudo"
          onClick={() => setArmado(false)}
        >
          Continuar aqui
        </button>
        <button
          type="button"
          className="botao botao--principal botao--miudo"
          onClick={() => {
            setArmado(false)
            aoIr()
          }}
        >
          Sim, voltar ao início
        </button>
      </div>
    </div>
  )
}
